import { createSelector } from 'reselect';
import { selectors } from '@crewmeister/shared';

const { selectEnabledTimeCategoriesInCurrentCrew } = selectors;

export const selectEnabledTimeCategoriesInCurrentCrewForTerminal = createSelector(
  selectEnabledTimeCategoriesInCurrentCrew,
  (timeCategories) => timeCategories.filter((timeCategory) => timeCategory.id !== null)
);
